import { ACTIVATE_LOADER, DE_ACTIVATE_LOADER } from '..';
import { 
    GET_REMOVE_CONVERSATION_AUTOMATION_DATA,
    TOGGLE_REMOVE_CONVERSATION_AUTOMATION,
    CREATE_REMOVE_CONVERSATION_AUTOMATION,
    UPDATE_REMOVE_CONVERSATION_AUTOMATION,
} from '../../sharedmailbox/settings/actionTypes';

const initialState = {
    active: false
}

export const loaderReducer = (state=initialState, action) => {
    const {type} = action;

    switch(type){

        case GET_REMOVE_CONVERSATION_AUTOMATION_DATA: 
        case TOGGLE_REMOVE_CONVERSATION_AUTOMATION:
        case CREATE_REMOVE_CONVERSATION_AUTOMATION: 
        case UPDATE_REMOVE_CONVERSATION_AUTOMATION:
        case ACTIVATE_LOADER:
        {
            return {
                ...state,
                active: true
            }
        }
        case `${GET_REMOVE_CONVERSATION_AUTOMATION_DATA}_SUCCESS`: 
        case `${TOGGLE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`: 
        case `${CREATE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`: 
        case `${UPDATE_REMOVE_CONVERSATION_AUTOMATION}_SUCCESS`: 
        case `${GET_REMOVE_CONVERSATION_AUTOMATION_DATA}_FAILED`: 
        case `${TOGGLE_REMOVE_CONVERSATION_AUTOMATION}_FAILED`: 
        case `${CREATE_REMOVE_CONVERSATION_AUTOMATION}_FAILED`: 
        case `${UPDATE_REMOVE_CONVERSATION_AUTOMATION}_FAILED`: 
        case DE_ACTIVATE_LOADER:
        {
            return {
                ...state,
                active: false
            }
        }  
        default: {
            return state
        }
    }
}

